/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FactorType } from './factorType';


/**
 * Project Work Plan View Taxonomy
 */
import { ValidateUtils } from 'app/shared/utils';

export class WorkPlanViewFactorTaxonomy { 
    factorType?: FactorType;
    /**
     * List of Factor Taxonomy Version identifiers
     */
    factorTaxonomyVersionResourceIdentifiers?: Array<string>;

    constructor(item?: Partial<WorkPlanViewFactorTaxonomy>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            factorType: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorType : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            factorTaxonomyVersionResourceIdentifiers: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorTaxonomyVersionResourceIdentifiers : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: WorkPlanViewFactorTaxonomy.isValid,
        };
    }

    static isValid(obj: WorkPlanViewFactorTaxonomy): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = WorkPlanViewFactorTaxonomy.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.factorType.isValid(item);
            result = result && validationObject.factorTaxonomyVersionResourceIdentifiers.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

